<template>
  <div class="envelope-content">
    <van-overlay :show="true" :z-index="13" class-name="content">
      <div class="popup_box_continer" id="canvas_parents">
        <div @click="onClickClose" v-if="!this.isActive" class="popup_close close_center">
          <span></span>
        </div>
        <canvas
          id="world"
          :class="showProgress ? 'canvas-continer-short' : 'canvas-continer'"
        ></canvas>
        <div class="active-name">{{ $t('envelope.title') }}</div>
        <div
          v-if="!showProgress"
          style="width: 100%; height: auto; margin-top: 0.7rem; z-index: 99; margin-bottom: 0.7rem"
        >
          <div v-show="boxStatus" class="con">
            <span class="from-text" v-if="inviteUser.length > 0">
              {{ fillterLongUserName(inviteUser) }} <br />
              {{ $t('envelope.sharebiggift') }}
            </span>
            <h1 style="font-size: 0.6rem; margin-top: 0.3rem">{{ $t('envelope.winupto') }}</h1>
            <h1>
              {{ envelopeData ? envelopeData.totalReward : envelopValue }}
              {{
                balance && balance.currencyAlias ? balance.currencyAlias : defaultCurrencyAlias()
              }}
            </h1>
          </div>
          <div class="box" :style="boxStatus ? 'margin-left: 0.25rem;' : ''">
            <div id="lottie" class="lottie" />
            <img class="normal" v-show="boxStatus" :src="`${resBaseUrl}gift-box01.png`" alt="" />
            <img class="open" v-show="!boxStatus" :src="`${resBaseUrl}gift-box02.png`" alt="" />
            <div class="money-tips" v-show="!boxStatus">{{ $t('envelope.receiveCash') }}</div>
            <div class="money" v-show="!boxStatus && envelopeData">
              {{ envelopeData ? envelopeData.currentReward : '--' }}
              {{
                balance && balance.currencyAlias ? balance.currencyAlias : defaultCurrencyAlias()
              }}
            </div>
          </div>
          <div
            class="button-continer"
            :style="inviteUser.length <= 0 ? 'margin-top:0.8rem' : 'margin-top:0.2rem'"
          >
            <div v-if="cooldown > new Date().getTime()" class="cooldown-group">
              <div class="open-button-grey">
                <span class="collect-time">COLLECT TIME</span>
                <span class="collect-str">{{ cooldownStr }}</span>
              </div>
              <div class="back-vivagame" @click="onBackVivaGame">BACK VIVAGAME</div>
            </div>
            <div v-else class="open-button" @click="openBox">
              {{
                boxStatus
                  ? $t('envelope.opennow')
                  : envelopeData && envelopeData.superSimple
                    ? $t('envelope.superSimple')
                    : $t('envelope.withdraw')
              }}
            </div>
          </div>
        </div>
        <div v-else class="progress_continer">
          <div class="amount_title">{{ $t('envelope.receiveCash') }}</div>
          <div class="amount">
            {{ envelopeData ? envelopeData.currentReward : '--' }}
            {{ balance && balance.currencyAlias ? balance.currencyAlias : defaultCurrencyAlias() }}
          </div>
          <ShareProgress :width="4" />
          <div class="title">{{ $t('envelope.popup.prompttoshare') }}</div>
          <div class="button" @click="onShare">
            {{
              envelopeData && envelopeData.superSimple
                ? $t('envelope.superSimple')
                : $t('envelope.popup.share')
            }}
          </div>
          <p
            class="totla_amount"
            v-html="$t('envelope.show.amont', { value: formatMoney(totleAmount) })"
          ></p>
        </div>
      </div>
      <img class="icon" v-if="!boxStatus" :src="`${resBaseUrl}bets.png`" alt="" />
    </van-overlay>
  </div>
</template>

<script>
import animationData from '@/assets/animation/box-effect-1.json'
import { config } from '@/common/config'
import { getLocalStorage, Key, removeLocalStorage } from '@/common/localStorage'
import { BUS, POPUP } from '@/event/EventCenter'
import { getLocale } from '@/locales'
import { useEnvelopeStore } from '@/stores/envelope'
import { useUserStore } from '@/stores/user'
import {
  activeCanvasAnimation,
  defaultCurrencyAlias,
  fillterLongUserName,
  formatMoney
} from '@/utils/helper'
import lottie from 'lottie-web'
import { mapActions, mapState } from 'pinia'
import ShareProgress from '@/components/active/ShareProgress.vue'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
dayjs.extend(duration)
export default {
  name: 'EnvelopeBoxComponent',
  components: {
    ShareProgress
  },
  props: {
    updateData: {
      type: Function,
      default: () => console.log('updateData:::envelopeBox')
    },
    inviteUser: {
      type: String,
      default: ''
    },
    hasOpened: {
      type: Boolean,
      default: false
    },
    showProgress: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      resBaseUrl: config.resBaseUrl,
      boxStatus: true,
      animation: null,
      envelopeData: null,
      isActive: import.meta.env.VITE_IS_ACTIVE == 'true',
      totleAmount: 0, //当期总领奖金额,
      envelopValue: '---',
      cooldownStr: '00:00:00',
      cooldown: 0
    }
  },
  watch: {
    hasOpened(newvalue, oldValue) {
      if (newvalue && newvalue != oldValue) {
        this.openBox()
      }
    }
  },
  computed: {
    ...mapState(useUserStore, ['isLogin', 'balance', 'userInfo', 'country']),
    ...mapState(useEnvelopeStore, ['reward', 'inviteUserId'])
  },
  mounted() {
    activeCanvasAnimation(document.getElementById('world'))
    this.animation = lottie.loadAnimation({
      container: document.getElementById('lottie'),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: animationData
    })
    this.envelopeData = this.reward
    if (this.isLogin) {
      this.envelope().then((res) => {
        if (res.id > 0 && res.status <= 3) {
          this.updateReward(res)
          this.cooldown = res.cooldown + new Date().getTime()
          this.cooldownStr = dayjs
            .duration(dayjs(this.cooldown).diff(dayjs()), 'milliseconds')
            .format('HH:mm:ss')
          let timer = setInterval(() => {
            if (dayjs(this.cooldown).isBefore(dayjs())) {
              clearInterval(timer)
              this.cooldownStr = '00:00:00'
              this.cooldown = -1
              return
            }
            this.cooldownStr = dayjs
              .duration(dayjs(this.cooldown).diff(dayjs()), 'milliseconds')
              .format('HH:mm:ss')
          }, 1000)
        }
      })
    } else {
      this.cooldown = 0
      this.cooldownStr = '00:00:00'
    }
    if (this.hasOpened) {
      this.openBox()
    }
    if (this.isActive) {
      this.totalClaimedReward().then((r) => {
        this.totleAmount = r.totalReward
      })
    }
    //此时未登录
    this.displayReward().then((r) => {
      this.envelopValue = r.totalReward == 0 ? '----' : r.totalReward
    })
  },
  methods: {
    formatMoney,
    fillterLongUserName,
    defaultCurrencyAlias,
    ...mapActions(useUserStore, { usernameSms: 'usernameSms', restPwd: 'restPwd' }),
    ...mapActions(useEnvelopeStore, {
      create: 'create',
      updateReward: 'updateReward',
      totalClaimedReward: 'totalClaimedReward',
      envelope: 'envelope',
      displayReward: 'displayReward'
    }),
    onBackVivaGame() {
      if (this.isActive && this.updateData) {
        const localHostName = {
          ET: 'www.vivagame.et',
          CI: 'www.vivagame.ci',
          KE: 'www.vivagame.ke',
          GH: 'www.bigwins.com.gh'
        }[this.country]
        window.location.href = 'https://' + localHostName + '?token=' + getLocalStorage(Key.Token)
      } else if (!this.isActive) {
        //在主站
        location.reload()
      }
    },
    openBox() {
      if (this.isLogin) {
        if (this.cooldown > 0) return
        if (this.boxStatus) {
          this.boxStatus = false
          if (this.animation) {
            this.animation.stop()
            this.animation.play()
          }
          this.create().then(async (r) => {
            this.envelopeData = r
            removeLocalStorage('invite')
          })
        } else {
          this.onClickClose()
        }
      } else {
        this.onClickClose()
        this.$bus.$emit(BUS.SHOW_POPUP, { from: 'EnvelopeBox', to: POPUP.REGISTER, show: true })
      }
    },
    onClickClose() {
      // const isActive = import.meta.env.VITE_IS_ACTIVE == 'true'
      if (this.isActive && this.updateData) {
        this.updateData(this.envelopeData)
      } else if (!this.isActive) {
        //在主站
        window.location.href = `${window.envelopeUrl}/?active=${getLocalStorage(Key.Token)}&lang=${getLocale()}&cid=hbzz&channel=web`
      }
    },
    onShare() {
      window.location.href = `${window.envelopeUrl}/?active=${getLocalStorage(Key.Token)}&lang=${getLocale()}&cid=hbzz&channel=web`
    }
  }
}
</script>

<style lang="scss" scoped>
.envelope-content {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 15;
}

.content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon {
  position: absolute;
  width: 2.75rem;
  height: 1.83rem;
  margin-top: calc(-100% - 0.91rem);
  margin-left: -44.5%;
}

.popup_box_continer {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-content: center;
  width: 5rem;
  height: auto;
  background-color: #000;
  background-image: linear-gradient(#000, #000),
    linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
  background-origin: border-box;
  background-clip: content-box, border-box;
  border-radius: 0.16rem;
  border: solid 0.04rem transparent;
  overflow: visible;

  .canvas-continer {
    opacity: 0.5;
    margin-bottom: -8.5rem;
    width: 5rem;
    height: 8.5rem;
  }

  .canvas-continer-short {
    opacity: 0.5;
    margin-bottom: -5.9rem;
    width: 5rem;
    height: 5.9rem;
  }

  .active-name {
    width: 100%;
    text-align: center;
    margin-top: 0.3rem;
    margin-bottom: -0.7rem;
    height: 0.5rem;
    line-height: 0.5rem;
    font-weight: 900;
    font-family: 'Droid Sans', Roboto, Arial, sans-serif;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 0.4rem;
    color: #aba9ac;
    background-image: -webkit-linear-gradient(#fff 24%, #ace523 24%, #009944 90%);
  }

  .con {
    width: 100%;
    margin-left: auto;
    // margin-bottom: 0px;
    margin-top: 0.5rem;
    z-index: 100;
    display: block;
    // position: absolute;
    margin-right: auto;

    h1,
    h2 {
      text-align: center;
      margin: auto;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    h1 {
      font-family: Oswald_Bold;
      font-size: 0.8rem;
      height: auto;
      color: #da9000;
      background-image: -webkit-linear-gradient(#fffba0 24%, #fffc00 26%, #da9000 80%);
      -webkit-text-stroke: 0.01rem #af4e00;
      line-height: 0.8rem;
    }

    h2 {
      font-size: 0.4rem;
      color: #aba9ac;
      line-height: 0.4rem;
      background-image: -webkit-linear-gradient(#fff 24%, #e7e7e7 24%, #aba9ac 90%);
    }

    .from-text {
      display: flex;
      justify-content: center;
      width: 5rem;
      height: auto;
      font-family: DroidSans;
      font-weight: bold;
      font-size: 0.3rem;
      color: #aba9ac;
      line-height: auto;
      padding-top: 0.2rem;
      text-shadow: 0px 0px 0px #000000;
      text-align: center;
      font-style: normal;
      text-transform: none;
      background: radial-gradient(0deg, #aba9ac 0%, #e7e7e7 100%);
    }
  }

  .box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    // flex-wrap: wrap;
    // position: fixed;
    // position: absolute;
    // top: 0;
    // left: 0;
    width: 100%;
    height: auto;
    // margin-top: 0.3rem;

    .normal {
      display: flex;
      width: 2.9rem;
      height: 3.1rem;
      margin-left: -0.5rem;
      margin-top: 0.5rem;
      // margin-left: 0.3rem;
      // animation: shake 0.5s infinite;
      animation: breathing 0.8s infinite;
      z-index: 11;
    }

    .open {
      display: flex;
      width: 5.6rem;
      height: 5.08rem;
      margin-top: 1rem;
      animation: mscale 0.5s forwards;
      // margin-left: -0.55rem;
    }

    .money {
      width: 100%;
      position: absolute;
      text-align: center;
      // margin: auto;
      margin-top: 2.3rem;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: Oswald_Bold;
      font-size: 0.8rem;
      height: auto;
      color: #da9000;
      background-image: -webkit-linear-gradient(#fffba0 24%, #fffc00 26%, #da9000 80%);
      -webkit-text-stroke: 0.01rem #af4e00;
      animation: mscale 0.5s forwards;
    }

    .money-tips {
      width: 100%;
      position: absolute;
      text-align: center;
      margin-top: 0.8rem;
      font-family: Oswald;
      font-weight: bold;
      font-size: 0.4rem;
      color: #aba9ac;
      line-height: 0.4rem;
      text-shadow: 0px 0px 0px #000000;
      text-align: center;
      font-style: normal;
      text-transform: none;
      scale: 0.8 1;
      // margin-left: -0.5rem;
      background: radial-gradient(0deg, #aba9ac 0%, #e7e7e7 100%);
    }

    .lottie {
      position: absolute;
      z-index: 10;
      scale: 1.8;
      // margin-bottom: -2.5rem;
      top: 7rem;
      left: -0.5rem;
    }
  }

  .button-continer {
    display: flex;
    justify-content: center;
    align-content: center;
    width: 5rem;
    height: auto;
    z-index: 999;
    // position: fixed;
    margin-top: 0.2rem;

    .cooldown-group {
      display: flex;
      justify-content: center;
      align-content: center;
      flex-direction: column;
      width: auto;
      height: 1.5rem;
      margin-top: 0.2rem;
      z-index: 99;
    }
    .back-vivagame {
      width: auto;
      height: 0.5rem;
      font-family: DroidSans;
      font-size: 0.24rem;
      color: #00a0e9;
      line-height: 0.36rem;
      text-align: center;
      font-style: normal;
      text-decoration-line: underline;
      text-transform: none;
      margin-top: 0.2rem;
    }
    .open-button-grey {
      display: flex;
      justify-content: center;
      align-content: center;
      flex-direction: column;
      flex-wrap: wrap;

      width: auto;
      min-width: 1.6rem;
      padding: 0 0.9rem;
      height: 0.96rem;
      background: #778989;
      border-radius: 0.48rem;
      // margin-top: 0.5rem;
      margin-top: 0;
      text-align: center;

      font-family: Roboto;
      font-weight: 400;
      font-size: 0.32rem;
      color: #ffffff;
      // margin-left: 0.3rem;
      z-index: 99;

      .collect-time {
        width: auto;
        height: 0.19rem;
        font-family: DroidSans;
        font-size: 0.24rem;
        color: #000000;
        line-height: 0.36rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-top: -0.3rem;
      }

      .collect-str {
        width: auto;
        height: 0.3rem;
        font-family: DroidSans;
        font-size: 0.4rem;
        color: #ffffff;
        line-height: 0.8rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
    .open-button {
      display: flex;
      justify-content: center;
      align-content: center;
      flex-wrap: wrap;

      width: auto;
      padding: 0 0.9rem;
      height: 0.96rem;
      background: #3b8d0b;
      border-radius: 0.48rem;
      // margin-top: 0.5rem;
      margin-top: 0;
      text-align: center;

      font-family: Roboto;
      font-weight: 400;
      font-size: 0.32rem;
      color: #ffffff;
      // margin-left: 0.3rem;
      z-index: 99;
    }
  }

  .progress_continer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: auto;
    margin-top: 1rem;

    .amount_title {
      width: auto;
      height: 0.26rem;
      font-family: DroidSans-Bold;
      font-weight: bold;
      font-size: 0.3rem;
      color: #aba9ac;
      line-height: 0.26rem;
      text-align: left;
      font-style: normal;
      text-transform: none;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-image: -webkit-linear-gradient(#aba9ac 24%, #e7e7e7 100%);
    }

    .amount {
      width: auto;
      height: 0.8rem;
      font-family: Oswald;
      font-weight: bold;
      font-size: 0.8rem;
      color: #fff;
      line-height: 1rem;
      text-shadow: inset 0px 1px 0px #ffffff;
      text-stroke: 0px #af4e00;
      text-align: left;
      font-style: normal;
      text-transform: none;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-image: -webkit-linear-gradient(#da9000 0%, #fffc00 100%);
    }

    .title {
      width: 80%;
      height: 0.19rem;
      font-family: Droid Sans;
      font-weight: 400;
      font-size: 0.24rem;
      color: #fff;
      line-height: 0.3rem;
      margin-top: 0.3rem;
      text-align: center;
    }

    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: auto;
      padding: 0 0.9rem;
      text-align: center;
      height: 0.7rem;
      background: #336aea;
      border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
      margin-top: 1rem;
      font-size: 0.24rem;
      z-index: 999;
    }

    .totla_amount {
      width: auto;
      height: 0.25rem;
      font-family: DroidSans;
      font-size: 0.24rem;
      color: #ffffff;
      line-height: 0.4rem;
      text-align: center;
      font-style: normal;
      text-transform: none;
      // margin-top: -0.59rem;
      margin-bottom: 0.3rem;

      .num {
        color: #f1d53a;
        font-family: Oswald-Bold;
        font-weight: bold;
        font-size: 0.24rem;
        line-height: 0.4rem;
      }
    }
  }
}

.close_center {
  display: flex !important;
  // margin-top: -0.5rem !important;
  justify-content: center;
  align-items: flex-start;
}

.popup_close {
  height: 0.8rem;
  width: 0.8rem;
  border-radius: 50%;
  background-color: #000;
  border: solid 0.04rem transparent;
  background-image: linear-gradient(#000, #000),
    linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
  background-origin: border-box;
  background-clip: content-box, border-box;
  margin-top: -5%;
  text-align: center;
  position: absolute;
  display: block;
  z-index: 999;
  margin-left: 60%;

  span {
    display: inline-block;
    width: 0.6rem;
    height: 0.06rem;
    background-color: #aa884a;
    background-image: linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
    transform: rotate(45deg);
    margin-top: 0.355rem;
  }

  span::after {
    content: '';
    display: block;
    width: 0.6rem;
    height: 0.06rem;
    background-color: #aa884a;
    background-image: linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
    transform: rotate(-90deg);
  }
}

@keyframes breathing {
  0% {
    transform: scale(1);
    // opacity: 1;
  }

  50% {
    transform: scale(1.05);
    // opacity: 0.7;
  }

  100% {
    transform: scale(1);
    // opacity: 1;
  }
}

@keyframes mscale {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}
</style>
